import {
  IS_SHOW_ZET_LESSON_DETAIL,
  RESET_STORE,
  ZET_LESSON_DETAIL_DATA,
} from "../types";

const initialState = {
  zetLessonData: null,
  open: false,
};

export const zetLessonReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case IS_SHOW_ZET_LESSON_DETAIL:
      return { ...state, open: payload };
    case ZET_LESSON_DETAIL_DATA:
      return { ...state, zetLessonData: payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
